import { useUserProducts } from '@/utils/authorization/user-products'
import { PRODUCT_FAMILIES, PRODUCT_PLANS } from '@/base/constants/Pricing'

export function getProductFamily(stripeProductId) {
  return PRODUCT_FAMILIES.find(productFamily =>
    productFamily.packages.find(productPlan => productPlan.stripeProductId === stripeProductId),
  )
}

export function getProductFamilyKey(stripeProductId) {
  return getProductFamily(stripeProductId)?.productKey
}

export function getProductTemplate(stripeProductId) {
  return PRODUCT_PLANS[stripeProductId]
}

export function getProductTemplateByPriceId(priceId) {
  return Object.values(PRODUCT_PLANS).find(productPlan => priceId?.includes(productPlan.stripeProductId))
}

export function useProduct() {
  const userProducts = useUserProducts()

  const getUserProduct = stripeProductId =>
    userProducts.value.find(product => product.name == stripeProductId)

  const getUserProductByProductFamily = productFamily =>
    userProducts.value.find(product => product.product == productFamily)

  const getRelatedActiveUserProduct = stripeProductId =>
    userProducts.value.find(product => product.product == getProductFamilyKey(stripeProductId))

  /**
   * Checks if the user's product corresponding to the provided product family is an enterprise product.
   *
   * @param {string} productFamily - The product family to find the user's product from.
   * @returns {boolean}
   */
  const isUserProductEnterpriseByFamily = (productFamily) => {
    const userProduct = getUserProductByProductFamily(productFamily)
    return !!userProduct && getProductTemplate(userProduct.name)?.isEnterprise
  }

  return {
    getUserProduct,
    getRelatedActiveUserProduct,
    getUserProductByProductFamily,
    isUserProductEnterpriseByFamily,
  }
}
